import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Observable, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Menu } from 'src/app/sidebar/sidebar-item/menu-types';
import { RoleService } from '../../role.service';
import { iconsArray } from '../menu-creation/icons';

@Component({
  selector: 'app-menu-creation-form',
  templateUrl: './menu-creation-form.component.html',
  styleUrls: ['./menu-creation-form.component.css']
})
export class MenuCreationFormComponent implements OnInit {

  @ViewChild("idMenu", {static: true}) IdMenu: ElementRef;
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;

  icons = iconsArray;
  menus: Array<Menu> = [];

  isUpdate = false;
  selectedId: string;
  selectedTitle: string;
  selectedIcon: string;
  selectedUrl: string;
  selectedReportId: string;
  selectedGroupId: string;
  selectedDatasetId: string;
  selectedPageNameId: string;

  constructor(
    private roleService: RoleService,
    @Inject(MAT_DIALOG_DATA) public data: Subject<string>,
    public dialogRef: MatDialogRef<MenuCreationFormComponent>
  ) { }

  ngOnInit() {
    const subs = this.data.subscribe(menuId => {
      if (menuId) {
        this.isUpdate = true;
        this.IdMenu.nativeElement.setAttribute('disabled', 'true');
        this.getMenu(menuId);
        subs.unsubscribe();
      }
    });

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value)),
    );
  }

  private getMenu(menu: string) {
    this.roleService.getMenu(menu)
    .subscribe(resp => {
      const menu = resp.result[0];
      this.selectedId = menu.menu_id;
      this.selectedTitle = menu.menu_title;
      this.selectedIcon = menu.icon;
      this.selectedUrl = menu.url;
      this.selectedReportId = menu.reportid;
      this.selectedGroupId = menu.groupid;
      this.selectedDatasetId = menu.datasetid;
      this.selectedPageNameId = menu.pagename;
    });
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase().replace(' ',  '_');
    return this.icons.filter(icon => icon.toLowerCase().includes(filterValue));
  }

  save() {
    const form = {
      menu_id: this.selectedId,
      menu_title: this.selectedTitle,
      icon: this.selectedIcon,
      url: this.selectedUrl,
      reportid: this.selectedReportId,
      groupid: this.selectedGroupId,
      datasetid: this.selectedDatasetId,
      pagename: this.selectedPageNameId
    };
    const obs = this.isUpdate ? this.roleService.updateMenu(form) : this.roleService.createMenu(form);
    const subs = obs.subscribe(_=> {
      this.data.next('ok');
      this.dialogRef.close();
      subs.unsubscribe();
    });
  }

  cancel() {
    this.dialogRef.close();
  }
}
